var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocumentBlue2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 3.75C12.4685 3.75 10.4165 5.80203 10.4165 8.33333V28.3333C10.4165 30.8646 12.4685 32.9167 14.9998 32.9167H29.9998C32.5311 32.9167 34.5832 30.8646 34.5832 28.3333V16.4837C34.5832 15.7518 34.308 15.0467 33.8123 14.5082L24.7745 4.69119C24.2222 4.09131 23.4441 3.75 22.6287 3.75H14.9998ZM6.6665 15.4167C7.35686 15.4167 7.9165 15.9763 7.9165 16.6667V30C7.9165 32.9915 10.3416 35.4167 13.3332 35.4167H23.3332C24.0235 35.4167 24.5832 35.9763 24.5832 36.6667C24.5832 37.357 24.0235 37.9167 23.3332 37.9167H13.3332C8.96092 37.9167 5.4165 34.3723 5.4165 30V16.6667C5.4165 15.9763 5.97615 15.4167 6.6665 15.4167Z",
    fill: "#A9D1FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7486_10265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 3,
    width: 25,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 3.75C12.4685 3.75 10.4165 5.80203 10.4165 8.33333V28.3333C10.4165 30.8646 12.4685 32.9167 14.9998 32.9167H29.9998C32.5311 32.9167 34.5832 30.8646 34.5832 28.3333V16.4837C34.5832 15.7518 34.308 15.0467 33.8123 14.5082L24.7745 4.69119C24.2222 4.09131 23.4441 3.75 22.6287 3.75H14.9998Z",
    fill: "#166DD7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7486_10265)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2991 1.31045C25.4816 0.222698 23.75 0.800935 23.75 2.16161V14.8286C23.75 15.6126 24.3867 16.2475 25.1707 16.2453L34.671 16.2185C35.8372 16.2152 36.5001 14.8829 35.7994 13.9506L26.2991 1.31045Z",
    fill: "#166DD7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentBlue2);
export default __webpack_public_path__ + "static/media/icon-document-blue2.f4c095bb5f7379901d96820c9e596bab.svg";
export { ForwardRef as ReactComponent };